import { createReducer, on } from '@ngrx/store';
import { zefResetState } from '@zerops/zef/core';
import { UserDataBaseState } from './user-data-base.model';
import {
  UserDataBaseActionUnion,
  setActiveId,
  revealUserDataSuccess,
  hideUserData,
  clearRevealedUserData
} from './user-data-base.action';

const initialState = new UserDataBaseState();

const actionReducer = createReducer(
  initialState,
  on(
    setActiveId,
    (s, { id }): UserDataBaseState => ({
      ...s,
      activeId: id
    })
  ),
  on(
    revealUserDataSuccess,
    (s, { data, originalAction }): UserDataBaseState => ({
      ...s,
      revealedContent: {
        ...s.revealedContent,
        [originalAction.data.id]: data.content
      }
    })
  ),
  on(
    hideUserData,
    (s, { id }): UserDataBaseState => {
      // drop the entry from a copy - state itself is never mutated
      const revealedContent = { ...s.revealedContent };
      delete revealedContent[id];
      return { ...s, revealedContent };
    }
  ),
  on(
    clearRevealedUserData,
    (s): UserDataBaseState => ({ ...s, revealedContent: {} })
  ),
  on(zefResetState, () => initialState)
);

export function userDataBaseReducer(
  state: UserDataBaseState,
  action: UserDataBaseActionUnion
) {
  return actionReducer(state, action);
}
